import { render, staticRenderFns } from "./dashboard-notifications.vue?vue&type=template&id=705848c6&scoped=true"
import script from "./dashboard-notifications.vue?vue&type=script&lang=js"
export * from "./dashboard-notifications.vue?vue&type=script&lang=js"
import style0 from "./dashboard-notifications.vue?vue&type=style&index=0&id=705848c6&prod&scoped=true&lang=css"
import style1 from "./dashboard-notifications.vue?vue&type=style&index=1&id=705848c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705848c6",
  null
  
)

export default component.exports